import {Extension} from '@tiptap/core'

const margin = (side: 'marginTop' | 'marginBottom', css: string) => ({
  default: null,
  parseHTML: (element: HTMLElement) => element.style[side] || null,
  renderHTML: (attributes: Record<string, string | null>) =>
    attributes[side] ? {style: `${css}: ${attributes[side]}`} : {},
})

/**
 * Keeps a block's own top/bottom margin. Word saves every line as its own
 * paragraph with `margin: 0`; dropping that let the editor's paragraph gap
 * (and, in sent emails, the default <p> margin) push every line apart, so
 * letters pasted from Word came out far taller than they were in Word.
 */
export const BlockSpacing = Extension.create({
  name: 'blockSpacing',

  addGlobalAttributes() {
    return [
      {
        types: ['paragraph', 'heading'],
        attributes: {
          marginTop: margin('marginTop', 'margin-top'),
          marginBottom: margin('marginBottom', 'margin-bottom'),
        },
      },
    ]
  },
})
